var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboEmailSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.65 2.3999H1.35C1.154 2.3999 1 2.5539 1 2.7499V13.2499C1 13.4459 1.154 13.5999 1.35 13.5999H14.65C14.846 13.5999 15 13.4459 15 13.2499V2.7499C15 2.5539 14.846 2.3999 14.65 2.3999ZM12.165 3.7999L8.196 6.9499C8.07 7.0479 7.895 7.0479 7.769 6.9499L3.576 3.7999H12.165ZM2.4 12.1999V4.6679L7.573 8.5529C7.832 8.7489 8.189 8.7419 8.448 8.5389L13.607 4.4509V12.1999H2.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboEmailSmall);
export default __webpack_public_path__ + "static/media/FBOEmailSmall.b6abc909a019ad31d2e6939e39009784.svg";
export { ForwardRef as ReactComponent };